import { Actions } from '../constants/Actions';
import { RelationshipActions } from '../constants/RelationshipActions';

export const APPS_PERMISSIONS = {
  MANAGE: `apps:${Actions.MANAGE}`,
  VIEW: `apps:${Actions.VIEW}`,
  CREATE: `apps:${Actions.CREATE}`,
  UPDATE: `apps:${Actions.UPDATE}`,
  DELETE: `apps:${Actions.DELETE}`,
  PUBLISH: `apps:${Actions.PUBLISH}`,
  UNPUBLISH: `apps:${Actions.UNPUBLISH}`,
  CLONE: `apps:${Actions.CLONE}`,
  EXPORT: `apps:${Actions.EXPORT}`,
  IMPORT: `apps:${Actions.IMPORT}`,
  ARCHIVE: `apps:${Actions.ARCHIVE}`,
  RESTORE: `apps:${Actions.RESTORE}`,
  ASSIGN_PARTNER: 'apps:assign_partner',
  ASSIGN_TENANT: `apps:${RelationshipActions.ASSIGN_TENANT}`,
  UNASSIGN_TENANT: 'apps:unassign_tenant',
  BUNDLES_MANAGE: 'bundles:manage',
};
